// eslint-disable-next-line import/prefer-default-export
export function mapToList(mapObj) {
  const result = [];
  // eslint-disable-next-line guard-for-in,no-restricted-syntax
  for (const key in mapObj) {
    result.push(mapObj[key]);
  }
  return result;
}
